var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    {
      attrs: {
        variant: "white",
        show: _vm.loadingFiles,
        "spinner-variant": "primary",
        blur: "0",
        opacity: ".75",
        rounded: "sm"
      }
    },
    [
      _c(
        "div",
        { attrs: { id: "list-dnt" } },
        [
          _c(
            "div",
            { staticClass: "d-flex search-bar" },
            [
              _c("vs-input", {
                staticClass: "mt-2 w-100",
                attrs: {
                  "icon-after": "true",
                  size: "small",
                  "label-placeholder": "icon-after",
                  icon: "mode_edit",
                  placeholder: "Buscar coincidencias",
                  "data-cy": "search"
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.fetchDocuments()
                  }
                },
                model: {
                  value: _vm.textSearch,
                  callback: function($$v) {
                    _vm.textSearch = $$v
                  },
                  expression: "textSearch"
                }
              }),
              _vm.searchParam
                ? _c("vs-button", {
                    staticClass: "ml-3",
                    attrs: {
                      radius: "",
                      color: "primary",
                      type: "border",
                      icon: "highlight_off",
                      size: "small"
                    },
                    on: {
                      click: function($event) {
                        return _vm.clearSearch()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("SimpleFilters", { attrs: { filtersFiles: _vm.filters } }),
          _c("FilesFilters", {
            attrs: {
              value: _vm.filters,
              onChange: _vm.onChangeFilters,
              clear: _vm.clearFilters
            }
          }),
          _c("FilesHeader", {
            attrs: { "on-pending-files": _vm.onPendingFiles }
          }),
          _c(
            "div",
            { key: _vm.forceRender, staticClass: "force-render" },
            _vm._l(_vm.filteredFiles, function(file) {
              return _c("FileRow", {
                key: file.febosId,
                attrs: {
                  file: file,
                  "on-pending-files": _vm.onPendingFiles,
                  "on-general-files": _vm.onGeneralFiles,
                  "on-support-files": _vm.onSupportFiles,
                  "on-processed-files": _vm.onProcessedFiles,
                  "on-entered-files": _vm.onEnteredFiles,
                  "on-pre-salida": _vm.onPreSalida,
                  "on-incomplete-files": _vm.onIncompleteFiles,
                  "select-file": _vm.selectFile,
                  "data-cy": "file"
                }
              })
            }),
            1
          ),
          _c("PopUpBinnacleFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpTimelineFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpReferencesFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpDetailFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpGeneralDetailFile", {
            attrs: { file: _vm.selectedFile },
            on: { reload: _vm.reload }
          }),
          _c("PopUpFlowFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpCancelFile", { attrs: { canceledFile: _vm.selectedFile } }),
          _c("PopUpProcessFile", {
            attrs: { processedFile: _vm.selectedFile }
          }),
          _c("KanbanTaskFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpControlReceivedFile", {
            attrs: { "control-file": _vm.selectedFile }
          }),
          _c("PopUpArchiveFile", {
            attrs: { processedFile: _vm.selectedFile }
          }),
          _c("PopUpRecoverFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpReturnFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpAsignFile", {
            attrs: { file: _vm.selectedFile },
            on: { reload: _vm.reload }
          }),
          _c("PopUpAnswerFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpParticipantsFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpCommentsFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpTicketFile", { attrs: { file: _vm.selectedFile } }),
          _vm.selectedFile
            ? _c("PopUpSendFile", { attrs: { file: _vm.selectedFile } })
            : _vm._e(),
          _c("PopUpNotifyFile", { attrs: { file: _vm.selectedFile } }),
          _c("PopUpActivityTimelineFile", {
            attrs: { file: _vm.selectedFile }
          }),
          _c("PopUpAnswerFileAguasAndinas", {
            attrs: { file: _vm.selectedFile }
          }),
          _c("PopUpViewResponseAguasAndinas", {
            attrs: { file: _vm.selectedFile }
          }),
          _vm.selectedFile
            ? _c("PopUpSendToDocDigital", {
                attrs: { file: _vm.selectedFile },
                on: { reload: _vm.reload }
              })
            : _vm._e(),
          _c("PopUpUpdatePrivacity", {
            attrs: { file: _vm.selectedFile },
            on: { reload: _vm.reload }
          }),
          _c(
            "vs-row",
            [
              _c("vs-col", { attrs: { "vs-lg": "3" } }, [
                _c("div", { staticClass: "mt-5" }, [
                  _vm._v(" Mostrando "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rowspp,
                          expression: "rowspp"
                        }
                      ],
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.rowspp = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.fetchDocuments()
                          }
                        ]
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { value: "10", selected: "selected" } },
                        [_vm._v("10")]
                      ),
                      _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                      _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                      _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
                    ]
                  ),
                  _vm._v(" registros por página. ")
                ])
              ]),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "9" } },
                [
                  _c("FilesPagination", {
                    attrs: { show: _vm.files.length },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }